import reloadIcon from "../../icons/reload.svg"
import './style.css'
import {useEffect, useRef, useState} from "react";
import clearIcon from "../../icons/clear.svg"
import searchIcon from "../../icons/search.svg"
import SearchInput from 'react-search-input'
import {clear} from "@testing-library/user-event/dist/clear";


const Index = ({loading, search, loadVehicles, vehicles}) => {
    const [refreshDisabled, setRefreshDisabled] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [focused, setFocused] = useState(false)

    useEffect(() => {
        search(searchText)
    }, [searchText])

    const refresh = () => {
        setRefreshDisabled(true)
        setTimeout(() => {
            setRefreshDisabled(false)
        }, 5000)
        loadVehicles()
    }

    return <div style={{display: "flex", gap: 8, width: "100%"}}>
        <div className={"search"}>
            <div className={"search-icon"}>
                <img alt="" src={searchIcon}/>
            </div>
            <div className={"search-input"}>
                <input
                    type={"text"}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    placeholder={focused ? "Укажите бортовой или гос. номер" : "Найти по номеру"}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}/>
            </div>
            {searchText.length > 0 ? <button onClick={() => setSearchText("")} className={"search-clear"}>
                <img alt="" src={clearIcon}/>
            </button> : null}
        </div>
        {vehicles?.length > 0 ? <div>
            <button disabled={loading || refreshDisabled} className={"refresh-button"} onClick={refresh}>
                <img style={{opacity: loading || refreshDisabled ? 0.5 : 1}} alt={""} src={reloadIcon}/>
            </button>
        </div> : null}
    </div>
}

export default Index